module.exports = __webpack_public_path__ + "img/about-grid-04.19a7d80e.jpg";